module.exports = __webpack_public_path__ + "static/media/chat-box.32cc1084.png";